import React from "react";
import ReactDOM from "react-dom";
import "normalize.css";
import "./styles/base.scss";
import App from "./App";
import { unregister } from "./serviceWorker";
import { GoogleOAuthProvider } from "@react-oauth/google";
import dotenv from "dotenv";

dotenv.config();

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
